import { useMemo } from 'react';
import { Badge, Tooltip } from 'seagull';
import { useIoContext } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { useLocaleKeys } from "../../../i18n";
import { billingBadgesTextsPath, getServiceDescriptionBadges } from "../../../utils/service-description/getServiceDescriptionBadges";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function BadgesList(props) {
  const {
    service,
    agreementData,
    testid,
    isFreshlyAdded,
    context,
    isReadOnly
  } = props;
  const featureFlags = useFeatureFlags();
  const {
    getNow
  } = useIoContext();
  const {
    t: billingBadgesTexts
  } = useLocaleKeys(billingBadgesTextsPath);
  const now = useMemo(() => getNow(), []);
  const {
    START_BILLING_AT_PHASE_2_INLINE
  } = featureFlags;
  const badgesList = getServiceDescriptionBadges(service, agreementData, now, featureFlags, {
    t: billingBadgesTexts,
    isFreshlyAdded,
    context,
    hidePausedBadge: !!START_BILLING_AT_PHASE_2_INLINE && !isReadOnly
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: badgesList.map(_ref => {
      let {
        text,
        intent,
        skin,
        tooltip,
        badgeTestid
      } = _ref;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tooltip || '',
        placement: "top",
        children: /*#__PURE__*/_jsx(Badge, {
          rounded: true,
          outlined: true,
          skin: skin,
          "data-testid": badgeTestid || "".concat(testid, "badge-").concat(intent),
          "data-intent": intent,
          children: text
        })
      }, intent);
    })
  });
}